import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { endpoints } from '../../api/endpoints';
import { DeleteAlertModal } from '../../components/modal/DeleteAlertModal';
import { TableHeadCell } from '../../components/styledComponent/table/TableCell';
import { TableRowsLoader } from '../../components/styledComponent/table/TableLoader';
import { Actions } from '../../components/table/TableActions';
import { Paper } from '@mui/material';
import { TablePagination } from '../../components/pagination/Pagination';
import { AppContext } from '../../contexts/AppContext';

export default function LockerTypeListTable({ setSelectedItem, setOpen, rows, count, skip, setSkip, take, setTake, refetch, loading }: { setOpen: any, setSelectedItem: any, rows: any, count: number, skip: number, setSkip: any, take: number, setTake: any, refetch: () => void, loading: any }) {

  const [openAlertModal, setOpenAlertModal] = React.useState(false);
  const [selectedId, setSelectedID] = React.useState<any | null>();
  const { user } = React.useContext(AppContext)

  const onSuccess = () => {
    setOpenAlertModal(false)
    setSelectedID(null)
    refetch()
  }

  const onError = () => {
    setOpenAlertModal(false)
    setSelectedID(null)
  }

  const deleteAction = (row: any) => {
    setSelectedID(row.id);
    setOpenAlertModal(true)
  }

  const editAction = (row: any) => {
    setSelectedItem(row)
    setOpen(true)
  }

  return (
    <>
      <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableHeadCell minwidth='5%'>S.N</TableHeadCell>
                <TableHeadCell align="left" style={{ padding: '4px 8px', fontSize: "12px" }} minwidth='15%'>Title </TableHeadCell>
                <TableHeadCell align="left" style={{ padding: '4px 8px', fontSize: "12px" }} minwidth='20%'>Rate </TableHeadCell>
                <TableHeadCell align="left" style={{ padding: '4px 8px', fontSize: "12px" }} minwidth='20%'>Held Amount</TableHeadCell>
                <TableHeadCell align="left" style={{ padding: '4px 8px', fontSize: "12px" }} minwidth='35%'>Dimension </TableHeadCell>
                {
                  user && (user?.role)?.toLowerCase() === 'admin' ? <TableHeadCell align="center" minwidth='5%'>Actions</TableHeadCell> : null
                }

              </TableRow>
            </TableHead>

            <TableBody>
              {!rows || loading ? <TableRowsLoader rowsNum={5} colNum={6} />
                : rows.length <= 0 ? <TableRow>
                  <TableCell colSpan={6} align='center'>No Data Found</TableCell>
                </TableRow>
                  : rows.map((row: any, index: number) => (
                    <TableRow
                      key={row.id}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell style={{ height: '50px', padding: '4px 8px', fontSize: "12px" }}>{skip > 0 ? skip * take + index + 1 : ++index}</TableCell>
                      <TableCell align="left" style={{ height: '50px', padding: '4px 8px', fontSize: "12px" }}>{row.title}</TableCell>
                      <TableCell align="left" style={{ height: '50px', padding: '4px 8px', fontSize: "12px" }}>{'NPR.'} {row.rate}</TableCell>
                      <TableCell align="left" style={{ height: '50px', padding: '4px 8px', fontSize: "12px" }}>{'NPR.'} {row.heldAmount ?? 0}</TableCell>
                      <TableCell align="left" style={{ height: '50px', padding: '4px 8px', fontSize: "12px" }}>{row.dimension}</TableCell>
                      {
                        user && (user?.role)?.toLowerCase() === 'admin' ? <TableCell align="center">
                          <Actions onDelete={deleteAction} onEdit={editAction} row={row} />
                        </TableCell> : null
                      }
                    </TableRow>
                  ))}
            </TableBody>
          </Table>
        </TableContainer>
        {rows?.length > 0 || !loading ? <TablePagination count={count} skip={skip} setSkip={setSkip} take={take} setTake={setTake} /> : null}
      </Paper>
      < DeleteAlertModal
        onSuccess={onSuccess}
        onError={onError}
        endpoint={endpoints.lockerType.api}
        selectedId={selectedId}
        openAlertModal={openAlertModal}
        setOpenAlertModal={setOpenAlertModal}
      />
    </>
  );
}
